import api from 'api'

export type EditRequirementQuestionParams = {
  requirementId: number
  questionId: number
  question: string
  idealAnswer: string
  evaluationCriteria: string
}

export const editRequirementQuestion = async ({
  requirementId,
  questionId,
  question,
  idealAnswer,
  evaluationCriteria,
}: EditRequirementQuestionParams): Promise<void> => {
  await api.patch(
    `/admin/requirement/${requirementId}/question/${questionId}`,
    {
      question,
      idealAnswer,
      evaluationCriteria,
    }
  )
}
